export default __webpack_public_path__ + "static/media/12.e9d58b03.gif";